import { createFileRoute } from '@tanstack/react-router'

import { MetricsPage } from '@/pages/metrics/Metrics.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/metrics',
)({
  component: MetricsPage,
  loader: () => ({ breadcrumbTitle: 'Metrics' }),
})
